import { render, staticRenderFns } from "./TermsAndConditionContent.vue?vue&type=template&id=51ee8081&scoped=true"
import script from "./TermsAndConditionContent.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionContent.vue?vue&type=script&lang=js"
import style0 from "./TermsAndConditionContent.vue?vue&type=style&index=0&id=51ee8081&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ee8081",
  null
  
)

export default component.exports